import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { Megaphone, Phone } from "lucide-react";
import { PHONE_TEL } from "@/data/spa";
import { useLang } from "@/i18n/LanguageContext";
import { TiltCard } from "@/components/spa/TiltCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PromoSpotlight = () => {
  const { t } = useLang();
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    axios.get(`${API}/promo`).then(({ data }) => data.enabled && data.message && setPromo(data)).catch(() => {});
  }, []);

  if (!promo) return null;

  return (
    <section data-testid="promo-spotlight" className="relative py-14 bg-[#050706]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <TiltCard
            max={3}
            lift={5}
            glow="0 22px 60px -18px rgba(197,160,89,0.55)"
            className="relative overflow-hidden border border-[#c5a059]/50 bg-gradient-to-r from-[#0e0c07] to-[#0c100e] px-8 py-8 lg:px-12 flex flex-col lg:flex-row lg:items-center gap-6"
          >
            <span aria-hidden="true" className="absolute -right-6 -top-12 font-serif-display text-[9rem] leading-none text-[#c5a059]/[0.07] select-none">季</span>
            <Megaphone size={26} className="text-[#c5a059] shrink-0" />
            <div className="flex-1 relative">
              {promo.title && (
                <h3 data-testid="promo-spotlight-title" className="font-serif-display text-2xl lg:text-3xl text-[#f0f4f2]">{promo.title}</h3>
              )}
              <p data-testid="promo-spotlight-message" className="mt-1 text-sm text-[#8a9690] font-light max-w-2xl">{promo.message}</p>
            </div>
            <a
              href={PHONE_TEL}
              data-testid="promo-spotlight-call"
              className="relative shrink-0 inline-flex items-center gap-3 bg-[#c5a059] text-[#050706] hover:bg-[#dcc286] px-7 py-3.5 text-xs tracking-[0.2em] uppercase font-medium transition-colors duration-300"
            >
              <Phone size={13} /> {t.nav.call} {`(720) 329-5714`}
            </a>
          </TiltCard>
        </motion.div>
      </div>
    </section>
  );
};
